import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {useKey} from 'react-use';

import Modal from 'components/Shared/Modals';
import Button from 'components/Shared/Common/Button';
import useUser from 'hooks/useUser';

const formatMessages = intl => ({ firstname, lastname }) => ({
    modalTitle: intl.formatMessage({
        id: 'modal.deleteRelation.title',
        defaultMessage: 'Supprimer la relation'
    }),
    modalContent: intl.formatMessage({
        id: 'modal.deleteRelation.content',
        defaultMessage: 'Voulez vous supprimer votre relation avec {firstname} {lastname} ?'
    }, {
        firstname,
        lastname
    }),
    buttonCancel: intl.formatMessage({
        id: 'global.button.cancel',
        defaultMessage: 'Annuler'
    }),
    buttonValid: intl.formatMessage({
        id: 'global.button.confirm',
        defaultMessage: 'Confirmer'
    })
});

const DeleteRelation = ({ intl, onClose, onSubmit, _user, firstname, lastname }) => {
    const { data } = useUser({ _user, enabled: !firstname && !lastname }); // if not present in redux, fetch it
    const i18n = formatMessages(intl)({ 
        firstname: firstname || data?.firstname, 
        lastname: lastname || data?.lastname 
    });

    const handleSubmit = useCallback((e) => {
        onSubmit(_user);
        onClose(e);
    }, [onSubmit, onClose, _user]);

    useKey('Enter', handleSubmit);

    return (
        <Modal
            isOpen
            title={i18n.modalTitle}
            footer={(
                <>
                    <Button
                        isTransparent
                        onClick={onClose}
                    >
                        {i18n.buttonCancel}
                    </Button>
                    <Button
                        color="danger"
                        onClick={handleSubmit}
                    >
                        {i18n.buttonValid}
                    </Button>
                </>
            )}
            onClose={onClose}
        >
            {i18n.modalContent}
        </Modal>
    );
}

DeleteRelation.propTypes = {
    intl: PropTypes.object.isRequired,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    _user: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default injectIntl(memo(DeleteRelation));
